module.exports = __webpack_public_path__ + "img/img2_mobile.fbf3a084.png";